var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3922 3.7679L18.7745 5.01235C22.6176 6.94815 25.0196 10.8543 25.0196 15.2099C25.0196 21.5012 19.9412 26.6173 13.6961 26.6173C7.45098 26.6173 2.37255 21.5012 2.37255 15.2099C2.37255 9.71358 6.21569 5.15062 11.3627 4.04444L11.6373 6.87901L14.7255 3.11111L10.9853 0L11.2255 2.66173C5.39216 3.83704 1 9.02222 1 15.2099C1 22.2617 6.69608 28 13.6961 28C20.6961 28 26.3922 22.2617 26.3922 15.2099C26.3922 10.3358 23.7157 5.94568 19.3922 3.7679Z",
    fill: "#FF5D02",
    stroke: "#FF5D02",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetries);
export default __webpack_public_path__ + "static/media/Retries.cd13f29a.svg";
export { ForwardRef as ReactComponent };